<template>
  <div class="my-2 border rounded shadow bg-white">
    <slot />
  </div>
</template>